module.exports = __webpack_public_path__ + "static/media/eng.6b65abf1.svg";